import { render } from "./ViewFlagRow.vue?vue&type=template&id=58d09d00&scoped=true"
import script from "./ViewFlagRow.vue?vue&type=script&lang=js"
export * from "./ViewFlagRow.vue?vue&type=script&lang=js"

import "./ViewFlagRow.vue?vue&type=style&index=0&id=58d09d00&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-58d09d00"

export default script